module.exports = __webpack_public_path__ + "img/pay-value12.3e3cbc96.png";